import React, { PropTypes } from 'react';

const Wrapper = ({ type, value, children }) => {
  const styles = require('./Wrapper.scss');
  if(type === 'wrapper_bg_fixed') {
    let innerStyle = value.inner.style || {};
    let imgix = value.imgix || '';
    innerStyle.backgroundImage = `url('http://quickshot.imgix.net/${value.image}?w=1000&h=1000&fit=crop&auto=format&q=45&cs=tinysrgb${imgix}')`;
    return (
      <div className={styles.bgfixedOuter} style={value.style}>
        <div className={styles.bgfixedMiddle} >
          <div className={styles.bgfixedInner} style={innerStyle}>
          </div>
        </div>
        <div style={value.content}>
          {children}
        </div>
      </div>
    );
  } else if (type === 'wrapper_fixed_content') {
    return (
      <div className={styles.bgfixedOuter} style={value}>
        <div className={styles.bgfixedMiddle} >
          <div className={styles.bgfixedInner} style={value.inner}>
            <div style={value.content}>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div style={value}>
      <div style={value.content}>
        {children}
      </div>
    </div>
  );

};

Wrapper.propTypes = {
  value: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node
};

export default Wrapper;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Wrapper/Wrapper.js
 **/